module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMzMzMzMgMTBIOS42NjY2N1Y4LjMzMzMzSDYuMzMzMzNWMTBaTTAuNSAwVjEuNjY2NjdIMTUuNVYwSDAuNVpNMyA1LjgzMzMzSDEzVjQuMTY2NjdIM1Y1LjgzMzMzWiIgZmlsbD0iIzdBN0E3QSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter-icon.svg
// module id = 6PKi
// module chunks = 1